module.exports = __webpack_public_path__ + "static/english-img1-08c71fc49202cbce9994df5b5f68b2ed.jpg";